import e, { Component as t } from "react";
import n from "prop-types";
import r from "react-dom";
import i from "react-jss";
import { jsx as a, jsxs as o } from "react/jsx-runtime";
import s from "moment";
//#region src/theme/theme.ts
var c = {
	textColorPrimary: "#292f34",
	primaryColor: "#2ab24a",
	primaryHover: "#1f8637",
	secondaryColor: "#edf1f6",
	secondaryHover: "#d7dbe0",
	borderColor: "#d9dee1",
	darkBorderColor: "#D7DBDF",
	errorColor: "#e36363",
	infoColor: "#4EAAC1",
	green: "#2ab24a",
	greenDark: "#1f8637",
	greenVeryDark: "#155b25",
	green80: "#55c16e",
	green50: "#94d8a4",
	green30: "#c0e8c9",
	green10: "#eaf8ed",
	green5: "#f4fbf6",
	grey: "#818589",
	greyDark: "#292f34",
	grey80: "#9a9da1",
	grey50: "#bfc1c3",
	grey30: "#dadbdc",
	grey20: "#e6e8e9",
	grey10: "#f3f3f4",
	grey5: "#f8f9f9",
	teal: "#4eaac1",
	tealDark: "#3a8092",
	teal80: "#71bbcd",
	teal50: "#a6d4df",
	teal30: "#cae6ed",
	teal10: "#eef7f9",
	teal5: "#f6fbfc",
	blue: "#445b7c",
	blueDark: "#31425b",
	blue80: "#697c96",
	blue50: "#a1acbd",
	blue30: "#c7ced8",
	blue10: "#edeff2",
	blue5: "#f5f7f8",
	purple: "#685b7a",
	purpleDark: "#4e435e",
	purple80: "#867c95",
	purple50: "#b3acbc",
	purple30: "#d2ced8",
	purple10: "#f0eff2",
	purple5: "#f7f7f8",
	pink: "#dc717d",
	pinkDark: "#a4545d",
	pink80: "#e38d97",
	pink50: "#edb7bd",
	pink30: "#f5d5d8",
	pink10: "#fcf1f2",
	pink5: "#fdf8f8",
	red: "#e36363",
	redDark: "#b54f4f",
	red80: "#e98282",
	red50: "#f0b0b0",
	red30: "#f7d1d1",
	red10: "#fdf0f0",
	red5: "#fdf7f7",
	redVeryDark: "#852020",
	orange: "#edaa64",
	orangeDark: "#be874e",
	orange80: "#f1bb83",
	orange50: "#f5d4b1",
	orange30: "#fae6d1",
	orange10: "#fef7f0",
	orange5: "#fefbf7",
	orangeVeryDark: "#7b5732",
	yellow: "#f2da51",
	yellowDark: "#c5af39",
	yellow80: "#f5e174",
	yellow50: "#f8eca7",
	yellow30: "#fcf4cb",
	yellow10: "#fefcee",
	yellow5: "#fefdf6",
	mauve: "#AD6B82",
	mauveDark: "#814459",
	mauve80: "#BD899B",
	mauve50: "#D5B4C0",
	mauve30: "#E7D3DA",
	mauve10: "#F7F1F3",
	mauve5: "#FBF7F9",
	text: "#292F34",
	white: "#ffffff"
}, l = {
	blue: {
		color: "#3a8092",
		backgroundColor: "#def9ff"
	},
	yellow: {
		color: "#c5b039",
		backgroundColor: "#fcf7da"
	},
	green: {
		color: "#1f8637",
		backgroundColor: "#dfffe6"
	},
	orange: {
		color: "#be874e",
		backgroundColor: "#f9ebdb"
	},
	grey: {
		color: "#525a63",
		backgroundColor: "#ecf1f5"
	},
	purple: {
		color: "#4E435E",
		backgroundColor: "#D8CBE9"
	},
	pink: {
		color: "#B54F4F",
		backgroundColor: "#FFB5B5"
	},
	red: {
		color: "#FFDFDF",
		backgroundColor: "#B54F4F"
	}
}, u = {
	grey: {
		color: c.greyDark,
		backgroundColor: c.grey30,
		iconBackgroundColor: c.grey50,
		hoverBackgroundColor: c.greyDark,
		hoverFillColor: c.white
	},
	green: {
		color: c.greyDark,
		backgroundColor: c.green30,
		iconBackgroundColor: c.green50,
		hoverBackgroundColor: c.green,
		hoverFillColor: c.white
	},
	yellow: {
		color: c.greyDark,
		backgroundColor: c.yellow30,
		iconBackgroundColor: c.yellow50,
		hoverBackgroundColor: c.yellow,
		hoverFillColor: c.greyDark
	},
	orange: {
		color: c.greyDark,
		backgroundColor: c.orange30,
		iconBackgroundColor: c.orange50,
		hoverBackgroundColor: c.orange,
		hoverFillColor: c.white
	},
	teal: {
		color: c.greyDark,
		backgroundColor: c.teal30,
		iconBackgroundColor: c.teal50,
		hoverBackgroundColor: c.teal,
		hoverFillColor: c.white
	},
	red: {
		color: c.greyDark,
		backgroundColor: c.red30,
		iconBackgroundColor: c.red50,
		hoverBackgroundColor: c.red,
		hoverFillColor: c.white
	},
	purple: {
		color: c.greyDark,
		backgroundColor: c.purple10,
		iconBackgroundColor: c.purple50,
		hoverBackgroundColor: c.purple,
		hoverFillColor: c.white
	}
}, d = {
	textHeaderColor: c.textColorPrimary,
	linkTextColor: "#4eaac2",
	linkTextHoverColor: "#3a8092",
	navigationBgColor: "#f7f9fa",
	avatarTextColor: "#ffffff",
	widgetHeaderTextColor: c.textColorPrimary,
	primaryButtonColor: c.primaryColor,
	primaryButtonHoverColor: c.primaryHover,
	secondaryButtonColor: c.secondaryColor,
	secondaryButtonHoverColor: c.secondaryHover,
	secondaryButtonTextColor: c.textColorPrimary,
	addButtonHoverColor: c.primaryHover,
	addButtonColor: "#1f8637",
	addButtonArrowHoverColor: "#18652a",
	navigationHoverBg: "#eff1f3",
	navigationActiveColor: c.primaryColor,
	disabledOpacity: .3,
	dragDropBorder: `2px dashed ${c.infoColor}`,
	dragDropOverBgColor: "rgba(78, 170, 193, .1)",
	dragDropDroppedBgColor: "#A7F7BA",
	dragDropDeniedBgColor: c.errorColor,
	dragDropOverDeniedBgColor: "rgba(227, 99, 99, .1)",
	menuBgColor: "#ffffff",
	borderRadius: "2px",
	alertBoxShadow: "0 7px 8px 0 rgba(0, 0, 0, 0.15)",
	alertSuccessColor: "#2AB24A",
	alertInfoColor: c.infoColor,
	alertWarningColor: "#E36363",
	alertCautionColor: "#EDAA64",
	menuBoxShadow: "0 7px 8px 0 rgba(0, 0, 0, 0.06)",
	menuPadding: "8px 1px",
	menuFontSize: "1rem",
	menuFontColor: c.textColorPrimary,
	menuItemHoverBg: "#f9f9fb",
	menuIconFillColor: "#99a1b0",
	menuIconHoverFillColor: c.primaryColor,
	menuSeparatorBorderColor: c.borderColor,
	datepickerPadding: "0 1px",
	datepickerWeekdayColor: "#aaaaaa",
	datepickerBgColor: "#fff",
	datepickerRangeBgColor: "#caecd2",
	datepickerDisabledColor: "#cccccc",
	userMenuChevronColor: c.textColorPrimary,
	filterDropdownSelectedTextColor: c.primaryColor,
	tableBorderColor: "#ebeef2",
	tableRowHoverBgColor: "#f9f9fb",
	tableHeaderTextColor: "#aaaaaa",
	tableTextColor: "#333333",
	tableDisabledColor: "#cccccc",
	donutChartTitleTextColor: "#3d413e",
	donutChartTooltipBorderColor: "#d9dce1",
	tooltipColor: "#99a1b0",
	tooltipFontSize: "0.8125rem",
	tooltipSmallFontSize: "0.875rem",
	impersonateBgColor: "#fcf1b1",
	sorterColor: "#d8d8d8",
	sorterActiveColor: "#292e34",
	checkboxBorderColor: "#99a1b0",
	checkboxHoverBorderColor: "#292e34",
	checkboxActiveBgColor: c.primaryColor,
	checkboxActiveBorderColor: "transparent",
	postDetailsFooterBgColor: c.secondaryColor,
	postDetailsFooterActionBgColor: c.primaryColor,
	postDetailsFooterPriceUOMColor: "#a9aeb3",
	modalFooterBorderColor: "#ebeef2",
	dayDisabledColor: "#cccccc",
	dayRangeBgColor: "#caecd2",
	dayBgColor: "#ffffff",
	datePickerWeekdayColor: "#aaaaaa",
	datePickerPadding: "0 1px",
	modalTextColor: "#333333",
	messageTimeColor: "#818589",
	selectAllBgColor: "rgba(42,178,74,0.08)",
	selectAllTextColor: "#292F34",
	hamburgerBorderColor: "#99a1b0",
	headerMobileBgColor: "#f7f8fa",
	alertBorderColor: c.darkBorderColor,
	fontFamily: "Roboto, sans-serif",
	pillBorderColor: c.darkBorderColor,
	pillBgColor: "#ecf1f5",
	pillFontColor: c.infoColor,
	pillIconFillColor: "#99A1B0",
	highchartsTooltipBorder: "solid 1px #3d413e",
	showMoreTextColor: c.infoColor,
	tabInactiveTextcolor: "#818589",
	tabInactiveBoxShadow: "0 1px 0 0 #EBEEF2",
	stepInactiveTextColor: "#D7DBDF",
	stepInactiveLineColor: "#D7DBDF",
	stepInactiveBorder: "solid 2px #D7DBDF",
	stepActiveBorder: `solid 2px ${c.primaryColor}`,
	editedTableRow: "#FBF6D9",
	toggleEditButton: c.infoColor,
	darkenedTextBox: "#292F34",
	editTableHeaderBackground: "#E8EDF3",
	editTableHeaderLabel: "#409AB3",
	editTableSaveButton: c.infoColor,
	sidebarCollapserColor: c.infoColor,
	badgeColors: l,
	accessibleBadgeColors: u,
	downArrowColor: "#D8000C",
	bubbleFilterTextColor: "#fffff",
	iqGradient: "linear-gradient(267deg, #07BEDF 0.64%, #2AB24A 68.08%, #F2DA51 111.11%)",
	...c
}, f = [
	"#445b7c",
	"#edaa64",
	"#ad6b82",
	"#4eaac2",
	"#f3da51",
	"#e36363",
	"#b2c4df",
	"#685b7a",
	"#fbd8b3",
	"#abdae6",
	"#fcf1b1",
	"#dc717d",
	"#d8cbea",
	"#f6b4cb",
	"#ffb4bd",
	"#f9ebdb"
], p = d;
//#endregion
//#region ../../node_modules/.pnpm/@babel+runtime@7.29.10/node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
function m(e, t) {
	if (e == null) return {};
	var n = {};
	for (var r in e) if ({}.hasOwnProperty.call(e, r)) {
		if (t.indexOf(r) !== -1) continue;
		n[r] = e[r];
	}
	return n;
}
//#endregion
//#region ../../node_modules/.pnpm/@babel+runtime@7.29.10/node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js
function h(e, t) {
	return h = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
		return e.__proto__ = t, e;
	}, h(e, t);
}
//#endregion
//#region ../../node_modules/.pnpm/@babel+runtime@7.29.10/node_modules/@babel/runtime/helpers/esm/inheritsLoose.js
function g(e, t) {
	e.prototype = Object.create(t.prototype), e.prototype.constructor = e, h(e, t);
}
//#endregion
//#region ../../node_modules/.pnpm/react-transition-group@4.4.5_react-dom@17.0.2_react@17.0.2__react@17.0.2/node_modules/react-transition-group/esm/config.js
var _ = { disabled: !1 }, v = process.env.NODE_ENV === "production" ? null : n.oneOfType([n.number, n.shape({
	enter: n.number,
	exit: n.number,
	appear: n.number
}).isRequired]);
process.env.NODE_ENV === "production" || n.oneOfType([
	n.string,
	n.shape({
		enter: n.string,
		exit: n.string,
		active: n.string
	}),
	n.shape({
		enter: n.string,
		enterDone: n.string,
		enterActive: n.string,
		exit: n.string,
		exitDone: n.string,
		exitActive: n.string
	})
]);
//#endregion
//#region ../../node_modules/.pnpm/react-transition-group@4.4.5_react-dom@17.0.2_react@17.0.2__react@17.0.2/node_modules/react-transition-group/esm/TransitionGroupContext.js
var y = e.createContext(null), b = function(e) {
	return e.scrollTop;
}, x = "unmounted", S = "exited", C = "entering", w = "entered", T = "exiting", E = /*#__PURE__*/ function(t) {
	g(n, t);
	function n(e, n) {
		var r = t.call(this, e, n) || this, i = n, a = i && !i.isMounting ? e.enter : e.appear, o;
		return r.appearStatus = null, e.in ? a ? (o = S, r.appearStatus = C) : o = w : o = e.unmountOnExit || e.mountOnEnter ? x : S, r.state = { status: o }, r.nextCallback = null, r;
	}
	n.getDerivedStateFromProps = function(e, t) {
		return e.in && t.status === "unmounted" ? { status: S } : null;
	};
	var i = n.prototype;
	return i.componentDidMount = function() {
		this.updateStatus(!0, this.appearStatus);
	}, i.componentDidUpdate = function(e) {
		var t = null;
		if (e !== this.props) {
			var n = this.state.status;
			this.props.in ? n !== "entering" && n !== "entered" && (t = C) : (n === "entering" || n === "entered") && (t = T);
		}
		this.updateStatus(!1, t);
	}, i.componentWillUnmount = function() {
		this.cancelNextCallback();
	}, i.getTimeouts = function() {
		var e = this.props.timeout, t = n = r = e, n, r;
		return e != null && typeof e != "number" && (t = e.exit, n = e.enter, r = e.appear === void 0 ? n : e.appear), {
			exit: t,
			enter: n,
			appear: r
		};
	}, i.updateStatus = function(e, t) {
		if (e === void 0 && (e = !1), t !== null) {
			if (this.cancelNextCallback(), t === "entering") {
				if (this.props.unmountOnExit || this.props.mountOnEnter) {
					var n = this.props.nodeRef ? this.props.nodeRef.current : r.findDOMNode(this);
					n && b(n);
				}
				this.performEnter(e);
			} else this.performExit();
		} else this.props.unmountOnExit && this.state.status === "exited" && this.setState({ status: x });
	}, i.performEnter = function(e) {
		var t = this, n = this.props.enter, i = this.context ? this.context.isMounting : e, a = this.props.nodeRef ? [i] : [r.findDOMNode(this), i], o = a[0], s = a[1], c = this.getTimeouts(), l = i ? c.appear : c.enter;
		!e && !n || _.disabled ? this.safeSetState({ status: w }, function() {
			t.props.onEntered(o);
		}) : (this.props.onEnter(o, s), this.safeSetState({ status: C }, function() {
			t.props.onEntering(o, s), t.onTransitionEnd(l, function() {
				t.safeSetState({ status: w }, function() {
					t.props.onEntered(o, s);
				});
			});
		}));
	}, i.performExit = function() {
		var e = this, t = this.props.exit, n = this.getTimeouts(), i = this.props.nodeRef ? void 0 : r.findDOMNode(this);
		!t || _.disabled ? this.safeSetState({ status: S }, function() {
			e.props.onExited(i);
		}) : (this.props.onExit(i), this.safeSetState({ status: T }, function() {
			e.props.onExiting(i), e.onTransitionEnd(n.exit, function() {
				e.safeSetState({ status: S }, function() {
					e.props.onExited(i);
				});
			});
		}));
	}, i.cancelNextCallback = function() {
		this.nextCallback !== null && (this.nextCallback.cancel(), this.nextCallback = null);
	}, i.safeSetState = function(e, t) {
		t = this.setNextCallback(t), this.setState(e, t);
	}, i.setNextCallback = function(e) {
		var t = this, n = !0;
		return this.nextCallback = function(r) {
			n && (n = !1, t.nextCallback = null, e(r));
		}, this.nextCallback.cancel = function() {
			n = !1;
		}, this.nextCallback;
	}, i.onTransitionEnd = function(e, t) {
		this.setNextCallback(t);
		var n = this.props.nodeRef ? this.props.nodeRef.current : r.findDOMNode(this), i = e == null && !this.props.addEndListener;
		if (!n || i) setTimeout(this.nextCallback, 0);
		else {
			if (this.props.addEndListener) {
				var a = this.props.nodeRef ? [this.nextCallback] : [n, this.nextCallback], o = a[0], s = a[1];
				this.props.addEndListener(o, s);
			}
			e != null && setTimeout(this.nextCallback, e);
		}
	}, i.render = function() {
		var t = this.state.status;
		if (t === "unmounted") return null;
		var n = this.props, r = n.children;
		n.in, n.mountOnEnter, n.unmountOnExit, n.appear, n.enter, n.exit, n.timeout, n.addEndListener, n.onEnter, n.onEntering, n.onEntered, n.onExit, n.onExiting, n.onExited, n.nodeRef;
		var i = m(n, [
			"children",
			"in",
			"mountOnEnter",
			"unmountOnExit",
			"appear",
			"enter",
			"exit",
			"timeout",
			"addEndListener",
			"onEnter",
			"onEntering",
			"onEntered",
			"onExit",
			"onExiting",
			"onExited",
			"nodeRef"
		]);
		return /*#__PURE__*/ e.createElement(y.Provider, { value: null }, typeof r == "function" ? r(t, i) : e.cloneElement(e.Children.only(r), i));
	}, n;
}(e.Component);
E.contextType = y, E.propTypes = process.env.NODE_ENV === "production" ? {} : {
	nodeRef: n.shape({ current: typeof Element > "u" ? n.any : function(e, t, r, i, a, o) {
		var s = e[t];
		return n.instanceOf(s && "ownerDocument" in s ? s.ownerDocument.defaultView.Element : Element)(e, t, r, i, a, o);
	} }),
	children: n.oneOfType([n.func.isRequired, n.element.isRequired]).isRequired,
	in: n.bool,
	mountOnEnter: n.bool,
	unmountOnExit: n.bool,
	appear: n.bool,
	enter: n.bool,
	exit: n.bool,
	timeout: function(e) {
		var t = v;
		e.addEndListener || (t = t.isRequired);
		var n = [...arguments].slice(1);
		return t.apply(void 0, [e].concat(n));
	},
	addEndListener: n.func,
	onEnter: n.func,
	onEntering: n.func,
	onEntered: n.func,
	onExit: n.func,
	onExiting: n.func,
	onExited: n.func
};
function D() {}
E.defaultProps = {
	in: !1,
	mountOnEnter: !1,
	unmountOnExit: !1,
	appear: !1,
	enter: !0,
	exit: !0,
	onEnter: D,
	onEntering: D,
	onEntered: D,
	onExit: D,
	onExiting: D,
	onExited: D
}, E.UNMOUNTED = x, E.EXITED = S, E.ENTERING = C, E.ENTERED = w, E.EXITING = T;
//#endregion
//#region src/utility/merge-refs.js
var O = (e, t) => !!Object.getOwnPropertyDescriptor(e, t)?.get?.isReactWarning, k = (e) => O(e.props, "ref") ? e.ref : O(e, "ref") ? e.props.ref : e.props.ref ?? e.ref, A = (e, t) => typeof e?.type == "string" ? t : void 0, ee = (e, t) => {
	typeof e == "function" ? e(t) : e && (e.current = t);
};
function j(...e) {
	return (t) => {
		e.forEach((e) => ee(e, t));
	};
}
//#endregion
//#region src/transitions/fade-in.jsx
var M = class extends t {
	constructor(e) {
		super(e), this.defaultStyle = {
			transition: `${e.duration} ease-in-out`,
			transitionProperty: "transform, opacity"
		}, this.transitionStyles = {
			entering: { opacity: 0 },
			entered: { opacity: 1 },
			exiting: { opacity: 1 },
			exited: { opacity: 0 }
		};
	}
	static propTypes = {
		children: n.node,
		duration: n.string
	};
	static defaultProps = { duration: "500ms" };
	nodeRef = e.createRef();
	renderChild = (t) => {
		let n = {
			...this.defaultStyle,
			...this.transitionStyles[t]
		};
		return e.cloneElement(this.props.children, {
			style: n,
			ref: j(this.nodeRef, k(this.props.children))
		});
	};
	render() {
		return /* @__PURE__ */ a(E, {
			...this.props,
			nodeRef: A(this.props.children, this.nodeRef),
			children: this.renderChild
		});
	}
}, N = {
	"@keyframes focus-ripple": {
		from: {
			transform: "scale(0.7, 1)",
			opacity: 1
		},
		to: {
			transform: "scale(0.9, 1)",
			opacity: 1
		}
	},
	"@keyframes focus-ripple-start-end": {
		"0%": {
			transform: "scale(0.0, 1)",
			opacity: 1
		},
		"50%": {
			transform: "scale(0.9, 1)",
			opacity: 1
		},
		"100%": {
			transform: "scale(0.7, 1)",
			opacity: 1
		}
	},
	"@keyframes ripple": {
		"0%": {
			transform: "scale(0, 0)",
			opacity: 1
		},
		"100%": {
			opacity: 0,
			transform: "scale(3, 3)"
		}
	},
	"@keyframes ripple-full-width": {
		"0%": {
			transform: "scale(0, 0)",
			opacity: 1
		},
		"100%": {
			opacity: 0,
			transform: "scale(5, 5)"
		}
	}
}, P = { "@keyframes table-loading": {
	"0%": { transform: "translateX(-50%)" },
	"100%": { transform: "translateX(100%)" }
} }, te = { "@keyframes fade": {
	"0%": { opacity: 0 },
	"100%": { opacity: 1 }
} }, ne = { "@keyframes loading-dash": { to: { strokeDashoffset: 0 } } }, re = {
	"@keyframes loading-bounce": {
		"0%": { transform: "translateY(-10px)" },
		"100%": { transform: "translateY(2px)" }
	},
	"@keyframes loading-squish": {
		"75%": { transform: "scale(1,1)" },
		"100%": { transform: "scale(1.2,0.7)" }
	},
	"@keyframes loading-stem": {
		"0%": { transform: "rotateZ(30deg) translate(0, 0)" },
		"75%": { transform: "rotateZ(30deg) translate(0, 0)" },
		"100%": { transform: "rotateZ(30deg) translate(3px, 6px)" }
	},
	"@keyframes loading-shadow-bounce": {
		"0%": {
			transform: "scale(1,1)",
			opacity: .1,
			filter: "blur(2px)"
		},
		"50%": {
			transform: "scale(1,1)",
			opacity: .1,
			filter: "blur(0px)"
		},
		"100%": {
			transform: "scale(1.2,1.2)",
			opacity: .3,
			filter: "blur(0px)"
		}
	}
}, ie = {
	"@keyframes focus-scale": {
		from: { transform: "scale(0.7, 0.7)" },
		to: { transform: "scale(0.85, 0.85)" }
	},
	"@keyframes focus-scale-start-end": {
		"0%": { transform: "scale(0.0, 0.0)" },
		"50%": { transform: "scale(0.85, 0.85)" },
		"100%": { transform: "scale(0.7, 0.7)" }
	}
}, ae = ({ style: e, className: t = "" }) => /* @__PURE__ */ a("svg", {
	"aria-hidden": "true",
	style: e,
	className: `sa-icon__information ${t}`,
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	viewBox: "0 0 16 16",
	children: /* @__PURE__ */ o("g", {
		id: "info-icon",
		stroke: "none",
		strokeWidth: "1",
		transform: "translate(1.333333, 0)",
		fillRule: "nonzero",
		children: [
			/* @__PURE__ */ a("path", { d: "M6.66666667,13.3333333 C2.99066667,13.3333333 0,10.3433333 0,6.66666667 C0,2.99133333 2.99066667,0 6.66666667,0 C10.3426667,0 13.3333333,2.99066667 13.3333333,6.66666667 C13.3333333,10.3433333 10.3426667,13.3333333 6.66666667,13.3333333 Z M6.66666667,1.33333333 C3.726,1.33333333 1.33333333,3.726 1.33333333,6.66666667 C1.33333333,9.60733333 3.726,12 6.66666667,12 C9.60733333,12 12,9.60733333 12,6.66666667 C12,3.726 9.60733333,1.33333333 6.66666667,1.33333333 Z" }),
			/* @__PURE__ */ a("path", {
				d: "M7.33333333,8.66666667 L7.33333333,6 C7.33333333,5.632 7.03533333,5.33333333 6.66666667,5.33333333 L5.33333333,5.33333333 L5.33333333,6.66666667 L6,6.66666667 L6,8.66666667 L4.66666667,8.66666667 L4.66666667,10 L8.66666667,10 L8.66666667,8.66666667 L7.33333333,8.66666667 Z",
				id: "Shape"
			}),
			/* @__PURE__ */ a("path", {
				transform: "translate(5.333333, 2.666667)",
				d: "M1.92261333,0.744076667 C2.24805,1.06951333 2.24805,1.59715 1.92261333,1.92259 C1.59717667,2.24802667 1.06954,2.24802667 0.7441,1.92259 C0.418663333,1.59715333 0.418663333,1.06951667 0.7441,0.744076667 C1.06953667,0.41864 1.59717333,0.41864 1.92261333,0.744076667"
			})
		]
	})
}), oe = ({ style: e, className: t = "" }) => /* @__PURE__ */ a("svg", {
	"aria-hidden": "true",
	style: e,
	className: `sa-icon__arrow ${t}`,
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	viewBox: "0 0 24 24",
	children: /* @__PURE__ */ a("path", { d: "M7 14l5-5 5 5z" })
}), se = {
	...ne,
	loading__container: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center"
	},
	loading__apple: {
		display: "flex",
		height: "75px",
		width: "75px"
	},
	apple__path: {
		fill: "none",
		stroke: "#2AB24A",
		strokeLinejoin: "round",
		strokeOpacity: 1,
		strokeWidth: 4,
		strokeDasharray: 100,
		strokeDashoffset: 200
	},
	apple__animated: { animation: "$loading-dash 2s linear infinite reverse" },
	apple__arrow: {
		strokeWidth: 3,
		strokeLinecap: "round"
	},
	"apple__arrow-a": { animation: "$loading-dash 2s 100ms linear infinite reverse" },
	"apple__arrow-b": { animation: "$loading-dash 2s 1050ms linear infinite forwards" },
	apple__stem: { animation: "$loading-dash 2s 150ms linear infinite forwards" }
}, ce = class extends t {
	static propTypes = { classes: n.object };
	render() {
		let e = `${this.props.classes.apple__animated} ${this.props.classes.apple__path}`, t = `${this.props.classes.apple__stem} ${this.props.classes.apple__path}`, n = `${this.props.classes.apple__arrow} ${this.props.classes["apple__arrow-a"]} ${this.props.classes.apple__path}`, r = `${this.props.classes.apple__arrow} ${this.props.classes["apple__arrow-b"]} ${this.props.classes.apple__path}`;
		return /* @__PURE__ */ a("div", {
			className: this.props.classes.loading__container,
			"data-element": "loading-large",
			children: /* @__PURE__ */ o("svg", {
				className: this.props.classes.loading__apple,
				"data-name": "sa-apple",
				xmlns: "http://www.w3.org/2000/svg",
				xmlnsXlink: "http://www.w3.org/1999/xlink",
				viewBox: "0 0 75 75",
				children: [
					/* @__PURE__ */ a("path", {
						id: "sa-apple-bottom",
						className: e,
						d: "M44.3,50.8c-1.5,1.5-4.1,2.6-6,3c-1.9,0.3-4.1,0.1-6.4-1.2c-3.1-1.7-5.4-5.1-5.4-7.1H12.3\n            c-0.1,0-0.2,0-0.3,0h-0.2c-0.1,0-0.6,0.1-0.6,0.2c0,0.3,0,0.5,0.1,0.8c0.9,3.6,2.2,7,4,10.3c1.5,2.6,3.2,5.1,5.2,7.4\n            c0.8,0.9,1.7,1.7,2.6,2.3c0.2,0.2,0.4,0.3,0.6,0.4c0.5,0.3,1,0.5,1.5,0.7c0.2,0.1,1.2,0.2,1.4,0.2c0.1,0,0.3,0,0.4,0\n            c0.2,0,0.3,0,0.5,0c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0.3-0.1,1.5-0.2,1.8-0.3l0.3-0.1l0.5-0.1c0.8-0.2,1.7-0.5,2.5-0.8\n            c0.1,0,0.2-0.1,0.3-0.1c0.1,0,0.5-0.2,0.6-0.2c0.6-0.2,1.2-0.4,1.7-0.6c0.6-0.2,1.3-0.3,1.9-0.3c0,0,0.1,0,0.1,0c0.2,0,0.4,0,0.5,0\n            c0.9,0,1.7,0.2,2.5,0.4c0.5,0.1,1,0.3,1.5,0.6c0.1,0,0.1,0.1,0.2,0.1c0.1,0,0.6,0.2,0.6,0.2c0.5,0.2,1.1,0.4,1.6,0.6\n            c0.1,0,0.6,0.2,0.7,0.3c0.2,0,0.3,0.1,0.5,0.2c0,0,0.2,0,0.2,0c0.2,0.1,0.4,0.1,0.6,0.1c0.2,0.1,1.2,0.1,1.4,0.2H48h0.2h0.2h0.1\n            c0.3,0,1.1-0.1,1.4-0.2c0.7-0.2,1.4-0.5,2.1-1c0.1,0,0.1-0.1,0.2-0.1c1.1-0.7,2-1.6,2.8-2.5c1.8-2,3.3-4.2,4.7-6.5\n            c1.9-3.2,3.4-6.6,4.3-10.4"
					}),
					/* @__PURE__ */ a("path", {
						id: "sa-apple-top",
						className: e,
						d: "M29.8,35.8c0.5-0.4,1.1-0.8,1.7-1.2c3.3-1.9,7.3-2.1,10.4-0.2c1.8,1.1,3.3,2.3,4.3,4.5h18\n            c0.2,0,0.7-0.1,0.7-0.2c0,0,0-0.1,0-0.1c0,0,0-0.3,0-0.3c0-0.2,0-0.4,0-0.6c0,0,0-0.1,0-0.2c0-0.8,0-1.5-0.1-2.2\n            c-0.1-1.1-0.2-2.1-0.5-3.1C63.9,30,63,27.9,61.8,26c-2.6-4.2-6.8-7-11.8-7.5c-1.4-0.2-2.8-0.1-4.1,0.2c-0.3,0.1-0.7,0.1-1,0.2\n            c-0.8,0.3-1.7,0.6-2.5,0.9c0,0-0.1,0-0.1,0c-0.3,0.1-0.5,0.2-0.8,0.3c0,0-0.1,0-0.1,0c-0.8,0.3-1.5,0.5-2.1,0.8\n            c-0.1,0-0.1,0-0.2,0.1c-1,0.1-1.5,0.2-2,0.1c-0.1,0-0.6-0.1-0.7-0.1c-0.3-0.1-0.6-0.1-0.9-0.2c-0.1,0-0.8-0.3-0.9-0.3\n            c0,0-0.1,0-0.1,0c-0.1,0-0.2-0.1-0.3-0.1c-1-0.4-2-0.7-3-1.1c0,0-0.1,0-0.1,0c-0.9-0.3-1.9-0.6-2.9-0.8c-1.1-0.2-2.2-0.2-3.3,0\n            c-4.9,0.6-9.2,3.3-11.8,7.5c-1.2,1.9-2.1,4-2.6,6.3c-0.3,1.3-0.4,2.4-0.5,3.7c0,0,0,0.1,0,0.2c0,0.2,0,0.7,0,1.5c0,0.1,0,0.2,0,0.3\n            c0,0.5,0,1.1,0,1.4"
					}),
					/* @__PURE__ */ a("path", {
						id: "sa-apple-stem",
						className: t,
						d: "M36.4,20.8c0-0.1-0.1-3.7,1-6.4c1.1-2.7,1.8-3.7,4-5.5c1.5-1.2,3.2-1.8,3.2-1.8"
					}),
					/* @__PURE__ */ o("g", {
						id: "sa-top-arrow",
						children: [/* @__PURE__ */ a("line", {
							id: "sa-top-arrow-b",
							className: r,
							x1: "28.8",
							y1: "36.9",
							x2: "32.3",
							y2: "36.9"
						}), /* @__PURE__ */ a("line", {
							id: "sa-top-arrow-a",
							className: n,
							x1: "28.9",
							y1: "33.5",
							x2: "28.8",
							y2: "36.9"
						})]
					}),
					/* @__PURE__ */ o("g", {
						id: "sa-bottom-arrow",
						children: [/* @__PURE__ */ a("line", {
							id: "sa-bottom-arrow-b",
							className: r,
							x1: "45.4",
							y1: "49.7",
							x2: "41.9",
							y2: "49.7"
						}), /* @__PURE__ */ a("line", {
							id: "sa-bottom-arrow-a",
							className: n,
							x1: "45.3",
							y1: "53.1",
							x2: "45.4",
							y2: "49.7"
						})]
					})
				]
			})
		});
	}
}, F = i(se)(ce), I = "20px", L = {
	...re,
	loading__container: {
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		justifyContent: "center",
		position: "relative"
	},
	loading__outer: {
		position: "relative",
		display: "block",
		height: I,
		width: I,
		animation: "$loading-bounce 500ms ease-in-out infinite alternate",
		zIndex: 2,
		transformOrigin: "center bottom"
	},
	loading__inner: {
		display: "block",
		height: I,
		width: I,
		borderRadius: "36% 36% 41% 41% / 42% 42% 75% 75%",
		border: `2px solid ${p.primaryColor}`,
		animation: "$loading-squish 500ms ease-out infinite alternate",
		transformOrigin: "center bottom"
	},
	"loading__inner--filled": { backgroundColor: p.primaryColor },
	loading__shadow: {
		display: "block",
		height: "5px",
		width: I,
		backgroundColor: "#000000",
		borderRadius: "100%",
		opacity: .2,
		zIndex: 1,
		animation: "$loading-shadow-bounce 500ms ease-in-out infinite alternate"
	},
	loading__stem: {
		display: "block",
		position: "absolute",
		borderRadius: "100%",
		border: "2px solid transparent",
		borderLeftColor: p.primaryColor,
		height: "12px",
		width: "12px",
		top: "-7px",
		left: "9px",
		transform: "rotateZ(10deg)",
		animation: "$loading-stem 500ms ease-out infinite alternate"
	}
}, R = class extends t {
	static propTypes = {
		classes: n.object,
		filled: n.bool
	};
	render() {
		let e = this.props.filled ? ` ${this.props.classes["loading__inner--filled"]}` : "", t = `${this.props.classes.loading__inner}${e}`;
		return /* @__PURE__ */ o("div", {
			className: this.props.classes.loading__container,
			"data-element": "loading-small",
			children: [/* @__PURE__ */ o("span", {
				className: this.props.classes.loading__outer,
				children: [/* @__PURE__ */ a("span", { className: this.props.classes.loading__stem }), /* @__PURE__ */ a("span", { className: t })]
			}), /* @__PURE__ */ a("span", { className: this.props.classes.loading__shadow })]
		});
	}
}, z = i(L)(R), B = {
	loading__wrapper: {
		height: "100%",
		display: "flex",
		flexDirection: "column",
		width: "100%",
		justifyContent: "center",
		alignItems: "center"
	},
	text__center: { textAlign: "center" }
}, V = class extends e.Component {
	state = { render: !0 };
	static propTypes = {
		classes: n.object,
		loading: n.bool,
		firstOnly: n.bool,
		error: n.object,
		children: n.element,
		size: n.string
	};
	static defaultProps = {
		firstOnly: !1,
		size: "large"
	};
	static getDerivedStateFromProps(e, t) {
		return e.firstOnly && t.render ? { render: e.loading } : null;
	}
	get loadingIcon() {
		return this.props.size === "large" ? /* @__PURE__ */ a(F, {}) : /* @__PURE__ */ a(z, {});
	}
	get loading() {
		return this.props.firstOnly ? this.state.render : this.props.loading;
	}
	render() {
		return /* @__PURE__ */ o("div", {
			className: this.props.classes.loading__wrapper,
			"data-element": "loading-wrapper",
			children: [
				this.props.error && /* @__PURE__ */ a("p", {
					className: this.props.classes.text__center,
					children: "An error occurred loading your activity."
				}),
				this.loading && /* @__PURE__ */ a(M, {
					appear: !0,
					in: this.loading,
					timeout: 0,
					children: this.loadingIcon
				}),
				!this.loading && /* @__PURE__ */ a(M, {
					appear: !0,
					in: !this.loading,
					timeout: 0,
					children: this.props.children
				})
			]
		});
	}
}, H = i(B)(V), U = 8, W = 16, le = {
	tooltipBox: {
		backgroundColor: "#fff",
		borderRadius: p.borderRadius,
		border: `1px solid ${p.borderColor}`,
		boxShadow: p.menuBoxShadow,
		fontSize: p.tooltipFontSize,
		textAlign: "center",
		position: "absolute",
		zIndex: 2e3,
		"& > *": {
			display: "block",
			padding: "18px"
		},
		"@global": { a: {
			color: p.linkTextColor,
			textDecoration: "none"
		} }
	},
	tooltipBoxSmall: {
		fontSize: p.tooltipSmallFontSize,
		"& > *": {
			display: "block",
			padding: "6px"
		}
	},
	tooltipHeader: {
		color: ({ headerTextColor: e }) => e,
		backgroundColor: ({ headerBackgroundColor: e }) => e
	},
	tooltipArrow: {
		transitionDuration: "200ms",
		position: "absolute",
		marginLeft: `-${W}px`,
		border: `${W}px solid transparent`,
		zIndex: 2e3,
		height: "16px",
		"&:before": {
			content: "\"\"",
			position: "absolute",
			left: `-${W}px`,
			border: `${W}px solid transparent`
		}
	},
	tooltipArrowTop: {
		borderTopColor: p.borderColor,
		borderBottomWidth: 0,
		bottom: "-16px",
		"&:before": {
			bottom: "1px",
			borderTopColor: "#fff",
			borderBottomWidth: 0
		}
	},
	tooltipArrowBottom: {
		borderBottomColor: p.borderColor,
		borderTopWidth: 0,
		top: "-16px",
		"&:before": {
			top: "1px",
			borderBottomColor: ({ header: e, headerBackgroundColor: t }) => e ? t : p.white,
			borderTopWidth: 0
		}
	},
	tooltipArrowSmall: {
		bottom: "-8px",
		marginLeft: `-${U}px`,
		borderWidth: `${U}px`,
		borderBottomWidth: 0,
		height: "8px",
		"&:before": {
			left: `-${U}px`,
			borderWidth: `${U}px`,
			borderBottomWidth: 0
		}
	},
	tooltipArrowSmallBottom: {
		top: "-8px",
		bottom: "auto",
		borderTopWidth: 0,
		borderBottomWidth: `${U}px`,
		"&:before": {
			borderTopWidth: 0,
			borderBottomWidth: `${U}px`
		}
	}
}, ue = class extends t {
	constructor(...e) {
		super(...e), this.setReference = (e) => {
			this.props.getReference(e);
		};
	}
	static {
		this.defaultProps = {
			headerTextColor: p.blueDark,
			headerBackgroundColor: p.blue5,
			showArrow: !0
		};
	}
	get arrowClass() {
		let { classes: e, small: t, bottom: n } = this.props, r = ` ${n ? e.tooltipArrowBottom : e.tooltipArrowTop}`, i = n && t ? ` ${e.tooltipArrowSmallBottom}` : "", a = t ? ` ${e.tooltipArrowSmall}` : "";
		return `${e.tooltipArrow}${a}${r}${i}`;
	}
	get boxClass() {
		let { classes: e, small: t } = this.props, n = t ? ` ${e.tooltipBoxSmall}` : "";
		return `${e.tooltipBox}${n}`;
	}
	render() {
		let { classes: e, header: t, text: n, style: r, arrowStyle: i, boxStyle: s, onMouseOver: c, onMouseOut: l, showArrow: u, className: d } = this.props, f = d || "";
		return /* @__PURE__ */ o("span", {
			"data-testid": "tooltip-content",
			role: "tooltip",
			style: r,
			onMouseOver: c,
			onMouseOut: l,
			children: [/* @__PURE__ */ o("span", {
				ref: this.setReference,
				style: s,
				className: this.boxClass,
				"data-element": "tooltip-content",
				children: [t && /* @__PURE__ */ a("span", {
					className: e.tooltipHeader,
					children: t
				}), /* @__PURE__ */ a("span", {
					className: f,
					children: n
				})]
			}), u && /* @__PURE__ */ a("span", {
				className: this.arrowClass,
				style: i,
				"data-element": "tooltip-arrow"
			})]
		});
	}
}, G = i(le)(ue), de = 2, K = 8, q = 16, J = 24, Y = class extends t {
	constructor(e) {
		super(e), this.window = {
			height: document.documentElement.clientHeight,
			width: document.documentElement.clientWidth,
			scrollTop: window.pageYOffset || document.documentElement.scrollTop,
			scrollLeft: window.pageXOffset || document.documentElement.scrollLeft
		}, this.state = { position: e.element.current.getBoundingClientRect() }, this.defaultStyle = {
			transition: "200ms ease-in-out",
			transitionProperty: "opacity",
			transitionDelay: "50ms"
		}, this.transitionStyles = {
			entering: { opacity: 0 },
			entered: { opacity: 1 },
			exiting: { opacity: 1 },
			exited: { opacity: 0 }
		};
	}
	static propTypes = {
		children: n.node,
		element: n.any,
		in: n.bool,
		bottom: n.bool,
		small: n.bool,
		additionalLeft: n.number,
		placement: n.string
	};
	static defaultProps = {
		bottom: !1,
		small: !1
	};
	static getDerivedStateFromProps({ element: e }) {
		return {
			position: e.current.getBoundingClientRect(),
			element: e.current
		};
	}
	setReference = (e) => {
		this.setState({ tooltip: e });
	};
	get bounding() {
		return {
			windowHeight: this.window.height,
			top: this.window.scrollTop + this.state.position.top - 4,
			bottom: -(this.window.scrollTop + this.state.position.bottom - this.window.height),
			left: this.window.scrollLeft + this.state.position.left,
			right: this.window.width - (this.window.scrollLeft + this.state.position.right),
			width: this.state.element.offsetWidth,
			height: this.state.element.offsetHeight
		};
	}
	get arrowSize() {
		return this.props.placement === "bottom-start" ? de : this.props.small ? K : q;
	}
	get arrowOffset() {
		return this.props.placement === "bottom-start" ? 3 : (this.props.small ? K : q) + 1;
	}
	get left() {
		if (this.props.placement === "bottom-start") return this.bounding.left;
		let e = this.bounding.left - this.tooltipOffset, t = this.tooltipWidth;
		return e + t > this.window.width ? e = this.window.width - J - t : e < 0 && (e = 24), this.props.additionalLeft ? e + this.props.additionalLeft : e;
	}
	get arrowTop() {
		return this.bottom ? this.bounding.top + this.bounding.height : this.bounding.top - this.arrowSize;
	}
	get top() {
		return this.bottom ? this.bounding.top + this.bounding.height + this.arrowSize : this.bounding.top - this.tooltipHeight - this.arrowSize;
	}
	get bottom() {
		let { bottom: e } = this.props;
		return this.state.position.top - this.tooltipHeight - this.arrowSize - J < 0 ? e = !0 : this.state.position.bottom + this.tooltipHeight + this.arrowSize + J > this.window.height && (e = !1), e;
	}
	get center() {
		return this.bounding.left + this.bounding.width / 2;
	}
	get tooltipOffset() {
		return this.bounding.left + this.tooltipWidth / 2 - this.center;
	}
	get tooltipWidth() {
		return this.state.tooltip ? this.state.tooltip.offsetWidth : 0;
	}
	get tooltipHeight() {
		return this.state.tooltip ? this.state.tooltip.offsetHeight : 0;
	}
	get transformBase() {
		return {
			top: this.top,
			left: this.left
		};
	}
	get arrowTransformBase() {
		return {
			top: this.arrowTop,
			left: this.center
		};
	}
	nodeRef = e.createRef();
	renderChild = (t) => e.cloneElement(this.props.children, {
		style: {
			...this.defaultStyle,
			...this.transitionStyles[t]
		},
		boxStyle: {
			...this.props.children.props.boxStyle,
			...this.transformBase
		},
		arrowStyle: this.arrowTransformBase,
		getReference: this.setReference,
		bottom: this.bottom,
		small: this.props.small,
		placement: this.props.placement,
		ref: j(this.nodeRef, k(this.props.children))
	});
	render() {
		return /* @__PURE__ */ a(E, {
			...this.props,
			nodeRef: A(this.props.children, this.nodeRef),
			children: this.renderChild
		});
	}
}, fe = {
	card: {
		boxShadow: "0 2px 3px 0 rgba(0, 0, 0, 0.05)",
		backgroundColor: "#fff",
		borderRadius: p.borderRadius,
		border: `1px solid ${p.borderColor}`,
		padding: "24px"
	},
	"card--no-padding": { padding: 0 }
}, pe = class extends e.Component {
	static propTypes = {
		children: n.node,
		className: n.string,
		id: n.string,
		noPadding: n.bool,
		classes: n.object,
		style: n.object
	};
	static defaultProps = { noPadding: !1 };
	render() {
		let { style: e, classes: t, noPadding: n, className: r, children: i, id: o } = this.props, s = `${t.card} ${n ? ` ${t["card--no-padding"]}` : ""} ${r ? ` ${r}` : ""}`;
		return /* @__PURE__ */ a("div", {
			className: s,
			style: e,
			"data-element": "card",
			id: o,
			children: i
		});
	}
}, X = i(fe)(pe), me = X, Z = class {
	constructor(e = 0) {
		this.fiscalYearStartMonth = e, this.now = /* @__PURE__ */ new Date();
	}
	year(e) {
		return e.getUTCMonth() < this.fiscalYearStartMonth ? e.getUTCFullYear() - 1 : e.getUTCFullYear();
	}
	get fiscalYearStart() {
		return this.fiscalYearStartByDate(this.now);
	}
	get fiscalYearEnd() {
		return this.fiscalYearEndByDate(this.now);
	}
	fiscalYearStartByDate(e) {
		return new Date(Date.UTC(this.year(e), this.fiscalYearStartMonth, 1));
	}
	fiscalYearEndByDate(e) {
		return new Date(Date.UTC(this.year(e), this.fiscalYearStartMonth + 12, 1, 0, 0, -1));
	}
	thisQuarter() {
		let e = this.now.getUTCMonth() - this.fiscalYearStartMonth;
		e = e < 0 ? 12 + e : e;
		let t = Math.ceil((e + 1) / 3), n = this.fiscalYearStart;
		n.setUTCMonth(n.getUTCMonth() + (t - 1) * 3);
		let r = new Date(Date.UTC(n.getUTCFullYear(), n.getUTCMonth() + 3, 1, 0, 0, -1));
		return {
			start: s.utc(n),
			end: s.utc(r)
		};
	}
	lastQuarter() {
		let e = this.thisQuarter(), t = e.start.toDate().getUTCMonth() - 3, n = e.start.toDate().getUTCFullYear(), r = new Date(Date.UTC(n, t, 1)), i = new Date(Date.UTC(r.getUTCFullYear(), r.getUTCMonth() + 3, 1, 0, 0, -1));
		return {
			start: s.utc(r),
			end: s.utc(i)
		};
	}
}, Q = 0, he = class {
	constructor(e = Q, t, n) {
		this.allTimeStartDate = t, this.fiscalYearStart = e, this.startDate = n, this.fiscalHelper = new Z(e), this.now = /* @__PURE__ */ new Date();
	}
	get allTimeStart() {
		return s.utc(this.allTimeStartDate);
	}
	get allTimeEnd() {
		return s.utc(new Date(Date.UTC(this.now.getUTCFullYear() + 1, 0, 1, 0, 0, -1)));
	}
	get chartAllTimeStart() {
		return Date.UTC(this.startDate.getUTCFullYear(), this.fiscalYearStart - 1, 16);
	}
	get chartAllTimeEnd() {
		return Date.UTC(this.startDate.getUTCFullYear(), this.fiscalYearStart + 11, 15, 23, 59, 59);
	}
	get fiscalYear() {
		return {
			start: s.utc(this.fiscalHelper.fiscalYearStart),
			end: s.utc(this.fiscalHelper.fiscalYearEnd)
		};
	}
	get lastFiscalYear() {
		return {
			start: s.utc(this.fiscalHelper.fiscalYearStart).subtract(1, "years"),
			end: s.utc(this.fiscalHelper.fiscalYearEnd).subtract(1, "years")
		};
	}
	get thisWeek() {
		let e = s.utc(this.now).startOf("weeks").add(1, "days");
		return {
			start: e,
			end: e.clone().endOf("weeks").add(1, "days")
		};
	}
	get lastWeek() {
		return {
			start: this.thisWeek.start.subtract(7, "days"),
			end: this.thisWeek.end.subtract(7, "days")
		};
	}
	get thisMonth() {
		return {
			start: s.utc(new Date(Date.UTC(this.now.getUTCFullYear(), this.now.getUTCMonth(), 1))),
			end: s.utc(new Date(Date.UTC(this.now.getUTCFullYear(), this.now.getUTCMonth() + 1, 1, 0, 0, 0, -1)))
		};
	}
	get lastMonth() {
		let { thisMonth: e } = this;
		return {
			start: e.start.month(e.start.month() - 1).startOf("month"),
			end: e.end.month(e.end.month() - 1).endOf("month")
		};
	}
	yearFromDateForChart(e) {
		return this.fiscalYearStart === Q ? e.getUTCFullYear() : this.fiscalHelper.fiscalYearStartByDate(e).getUTCFullYear();
	}
	stackedColumnChartUTCDate(e) {
		return Date.UTC(e.getUTCFullYear(), e.getUTCMonth(), 1);
	}
	useDailyInterval(e, t) {
		return t - e < 76896e5;
	}
	inSameFiscalYear(e, t) {
		return this.yearFromDateForChart(e) === this.yearFromDateForChart(t);
	}
	get timeframeRanges() {
		let e = this.fiscalHelper.thisQuarter(), t = this.fiscalHelper.lastQuarter(), n = `This ${this.fiscalYearStart > Q ? "Fiscal " : ""}Year`, r = `Last ${this.fiscalYearStart > Q ? "Fiscal " : ""}Year`;
		return [
			{
				label: "All Time",
				start: this.allTimeStart,
				end: this.allTimeEnd
			},
			{
				label: "This Week",
				start: this.thisWeek.start,
				end: this.thisWeek.end
			},
			{
				label: "Last Week",
				start: this.lastWeek.start,
				end: this.lastWeek.end
			},
			{
				label: "This Month",
				start: this.thisMonth.start,
				end: this.thisMonth.end
			},
			{
				label: "Last Month",
				start: this.lastMonth.start,
				end: this.lastMonth.end
			},
			{
				label: "This Quarter",
				start: e.start,
				end: e.end
			},
			{
				label: "Last Quarter",
				start: t.start,
				end: t.end
			},
			{
				label: n,
				start: this.fiscalYear.start,
				end: this.fiscalYear.end
			},
			{
				label: r,
				start: this.lastFiscalYear.start,
				end: this.lastFiscalYear.end
			}
		];
	}
	yearOverYearChartTimeRange(e, t) {
		let n = t.getTime() - e.getTime(), r = Date.UTC(e.getUTCFullYear(), e.getUTCMonth(), e.getUTCDate(), -6, 0, 0), i = Date.UTC(t.getUTCFullYear(), t.getUTCMonth(), t.getUTCDate(), t.getUTCHours() - 6, t.getUTCMinutes(), t.getUTCSeconds(), t.getUTCMilliseconds());
		return n > 76896e5 && this.inSameFiscalYear(e, t) ? (r = s.utc(r).subtract(16, "days").toDate().getTime(), i = s.utc(i).subtract(16, "days").toDate().getTime()) : this.inSameFiscalYear(e, t) || (r = this.chartAllTimeStart, i = this.chartAllTimeEnd), {
			startDate: r,
			endDate: i
		};
	}
	stackedColumnChartTimeRange(e, t) {
		let n = Date.UTC(e.getUTCFullYear(), e.getUTCMonth(), e.getUTCDate()), r = Date.UTC(t.getUTCFullYear(), t.getUTCMonth(), t.getUTCDate(), t.getUTCHours(), t.getUTCMinutes(), t.getUTCSeconds(), t.getUTCMilliseconds());
		return this.useDailyInterval(n, r) || (n = this.stackedColumnChartUTCDate(e), r = this.stackedColumnChartUTCDate(t)), {
			startDate: n,
			endDate: r
		};
	}
}, ge = { tooltip__container: {
	display: "inline-block",
	position: "relative"
} }, $ = class extends t {
	timer = null;
	portalTimer = null;
	static propTypes = {
		classes: n.object,
		children: n.node,
		header: n.string,
		text: n.node,
		small: n.bool,
		alwaysShow: n.bool,
		bottom: n.bool,
		hideTimeInMs: n.number,
		headerTextColor: n.string,
		headerBackgroundColor: n.string,
		showArrow: n.bool,
		boxStyle: n.object
	};
	static defaultProps = {
		alwaysShow: !1,
		hideTimeInMs: 250
	};
	state = {
		show: this.props.alwaysShow,
		portalOpen: this.props.alwaysShow
	};
	showText = () => {
		window.clearTimeout(this.timer), this.props.alwaysShow || this.setState({
			show: !0,
			portalOpen: !0
		});
	};
	hideText = () => {
		this.props.alwaysShow || (window.clearTimeout(this.timer), this.timer = window.setTimeout(() => {
			this.setState({ show: this.props.alwaysShow });
		}, this.props.hideTimeInMs + 50));
	};
	container = e.createRef();
	get show() {
		return this.container.current !== void 0 && this.state.show;
	}
	closePortal = () => {
		window.clearTimeout(this.portalTimer), this.portalTimer = window.setTimeout(() => {
			this.setState({ portalOpen: this.props.alwaysShow });
		}, this.props.hideTimeInMs);
	};
	componentWillUnmount() {
		window.clearTimeout(this.timer), window.clearTimeout(this.portalTimer);
	}
	get showPortal() {
		return this.container.current && this.state.portalOpen;
	}
	get portal() {
		let { header: e, text: t, small: n, bottom: i, headerTextColor: o, headerBackgroundColor: s, showArrow: c, boxStyle: l } = this.props;
		return r.createPortal(/* @__PURE__ */ a(Y, {
			in: this.show,
			appear: !0,
			exit: !0,
			timeout: 0,
			getReference: this.container,
			element: this.container,
			onExited: this.closePortal,
			bottom: i,
			small: n,
			children: /* @__PURE__ */ a(G, {
				header: e,
				text: t,
				small: n,
				headerTextColor: o,
				headerBackgroundColor: s,
				onMouseOver: this.showText,
				onMouseOut: this.hideText,
				showArrow: c,
				boxStyle: l
			})
		}), document.body);
	}
	componentDidMount() {
		this.setState({
			show: this.props.alwaysShow,
			portalOpen: this.props.alwaysShow
		});
	}
	render() {
		let { classes: e, children: t } = this.props;
		return /* @__PURE__ */ o("span", {
			"data-testid": "tooltip",
			className: e.tooltip__container,
			ref: this.container,
			onMouseOver: this.showText,
			onMouseOut: this.hideText,
			"data-element": "tooltip",
			children: [t, this.showPortal && this.portal]
		});
	}
}, _e = i(ge)($), ve = {
	nodata__container: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		height: "100%"
	},
	nodata__text: { textAlign: "center" }
}, ye = class extends t {
	static propTypes = { classes: n.object };
	render() {
		let { classes: e } = this.props;
		return /* @__PURE__ */ a("div", {
			className: e.nodata__container,
			children: /* @__PURE__ */ a("p", {
				className: e.nodata__text,
				"data-element": "no-data-available",
				children: "No data available"
			})
		});
	}
}, be = i(ve)(ye);
//#endregion
export { c as A, y as C, u as D, p as E, l as O, E as S, m as T, P as _, me as a, A as b, G as c, F as d, oe as f, N as g, ie as h, Z as i, d as j, f as k, H as l, te as m, _e as n, X as o, ae as p, he as r, Y as s, be as t, z as u, M as v, g as w, j as x, k as y };

//# sourceMappingURL=chunk-B-FQoMNn.mjs.map